var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGoogleDrive = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 17"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#google-drive_svg__a)",
  d: "M6.695.07h6.778l6.374 10.989h-6.793z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#google-drive_svg__b)",
  d: "m19.847 11.059-3.396 5.872H3.732l3.404-5.872z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#google-drive_svg__c)",
  d: "M3.732 16.93.351 11.06 6.695.069l3.404 5.887z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "m3.732 16.93 6.329-5.871H7.136zM19.847 11.059h-6.786L11.57 8.485zM6.695.07l1.957 8.377 1.447-2.49z",
  opacity: 0.1
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "google-drive_svg__a",
  x1: 6.695,
  x2: 2846.68,
  y1: 0.069,
  y2: 2947.58,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F6C338"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.523,
  stopColor: "#FFD351"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F6C338"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "google-drive_svg__b",
  x1: 4129.18,
  x2: 3044.62,
  y1: 11.059,
  y2: 2592.29,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#286EE6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.521,
  stopColor: "#4286FB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#286EE6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "google-drive_svg__c",
  x1: 1629.67,
  x2: -186.875,
  y1: 0.069,
  y2: 3109.04,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#069B5A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.531,
  stopColor: "#11AA62"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#069B5A"
})))));
export default SvgGoogleDrive;